import React, {useState} from 'react'
import { Formik, Form } from 'formik';
import { Button, FormGroup } from 'reactstrap';
import trialEmailSchema from "./trialEmailSchema";
import {onboard_step_path, onboard_steps_path} from "../../../routes";
import TextField from "../FormField/TextField";
import './signUpForm.scss'
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";

const SignUpForm = () => {
  const [googleErrorMsg, setGoogleErrorMsg] = useState()
  const params = new URLSearchParams(document.location.search);
  const subPlanId = params.get('sub_plan_id')

  const INITIAL_STATE = {
    email: '',
    password: '',
  }

  const handlegoogleSignin = async (credentialResponse, setFieldError ) => {
    const authorizationCode = credentialResponse.credential;
    const {email, name} = jwt_decode(authorizationCode)
    const fullName = name.split(" ")
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        id: 1,
        first_name: fullName[0],
        last_name: fullName[fullName.length - 1]
      })
    };
    await httpRequestHandler(requestOptions, setFieldError, true)
  }

  const handleSubmit = async (values, { setFieldError }) => {
    const { email, password } = values
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        id: 1,
        password,
      })
    };
    await httpRequestHandler(requestOptions, setFieldError)
  }

  const httpRequestHandler = async (requestOptions, setFieldError, signUpViaGoogle = false) => {
    const response = await fetch(onboard_steps_path({format: 'json'}), requestOptions)

    response.json().then(result => {
      if (!response.ok) {
        const emailError = (result && result.email)
        if (emailError) {
          setFieldError('email', <span>{emailError} <a href='mailto:contact@hubbleiq.com'>Contact us!</a></span>)
          if (signUpViaGoogle) {
            setGoogleErrorMsg(emailError)
          }
        }

        return Promise.reject(emailError)
      } else if (response.ok) {
        if (subPlanId) {
          window.location = onboard_step_path(result.next_step, {sub_plan_id: subPlanId})
        } else {
          window.location = onboard_step_path(result.next_step)
        }
      }
    })
    .catch(error => {
      console.log('ERROR!', error)
    })
  } 
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={INITIAL_STATE}
      validationSchema={trialEmailSchema()}
    >
      {({handleSubmit, isValid, dirty, setFieldValue, setFieldError}) => (
        <Form onSubmit={handleSubmit} className="form form_signup">
          {googleErrorMsg && (
            <span className='google-err-singin-msg'>
             {googleErrorMsg} {' '}
             <a href='mailto:contact@hubbleiq.com'>Contact us!</a>
            </span>
          )}
          <div className='mt-3 w-100 mb-3'>
            <GoogleLogin
              width={400}
              onSuccess={credentialResponse => handlegoogleSignin(credentialResponse, setFieldError)}
              onError={() => {
                console.log('Login Failed');
              }}
            />
          </div>
          <div className="hr-sect"><span>Or</span></div>
          <FormGroup>
            <TextField name="email" label="Work email address" placeholder="Enter your work email" />
          </FormGroup>
          <FormGroup>
            <TextField name="password" label="Create password" placeholder="Enter a password" inputtype="password" />
          </FormGroup>
          <FormGroup>
            <Button
              type="submit"
              id="start-free-trial"
              className="button button-default w-100"
              disabled={!isValid || !dirty}
            >
              Launch My Dashboard Now
            </Button>
          </FormGroup>
          <div className='disclosure'>
            By continuing, you are agreeing to the HubbleIQ <a href="https://www.hubbleiq.com/terms-of-use">Terms of Use</a> and <a href="https://www.hubbleiq.com/privacy-policy">Privacy Policy</a>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default SignUpForm
